<template>
	<div>
		<p><router-link to="/events/create" class="btn btn-primary"><i class="fa fa-plus"></i> Создать мероприятия</router-link></p>
		<vuetable ref="vuetable"
			:fields="columns"
			:api-mode="false"
			:data="tableData"
			@vuetable:cell-dblclicked="rowClickHandler"
			noDataTemplate="Ничего не найдено"
			class="table-striped"
		>
			<template slot="id" slot-scope="props">
				{{ props.rowData.id }}
			</template>
			<template slot="start_at" slot-scope="props">
				{{ dateFormat(props.rowData.start_at) }}
			</template>
			<template slot="duration" slot-scope="props">
				{{ props.rowData.duration }}
			</template>
			<template slot="actions" slot-scope="props">
				<b-dropdown variant="info" class="">
					<template slot="button-content"><i class="icon-settings"></i></template>
					<b-dropdown-item @click="actionEditHandler(props.rowData.id)"><i class="icon-pencil"></i>Редактировать</b-dropdown-item>
				</b-dropdown>
			</template>
		</vuetable>
	</div>
</template>
<script>
import moment from 'moment'
import eventAPI from '@/api/modules/event/event'
export default {
	data () {
		return {
			tableData: [],
			columns: [
				{
					name: '__slot:id',
					title: 'ID'
				}, {
					name: 'product.title',
					title: 'Название'
				}, {
					name: '__slot:start_at',
					title: 'Дата начала'
				}, {name: '__slot:duration',
					title: 'Продолжительность'
				}, {
					name: '__slot:actions',
					title: 'Действия'
				}
			]
		}
	},
	props: {
		startAt: {
			type: String,
			default: null
		}
	},
	created () {
		this.getProducts()
	},
	methods: {
		getProducts: function () {
			let params = {}
			if (this.startAt !== null) params.start = this.startAt

			eventAPI.findAll(params).then((response) => {
				this.tableData = response
			}, function (response) {
			})
		},
		dateFormat: function (date) {
			return moment(date).format('DD.MM.Y')
		},
		rowClickHandler (dataItem, field, event) {
			this.$router.push({path: `/events/${dataItem.id}/view`})
		},
		actionEditHandler (id) {
			this.$router.push({path: `/events/${id}/update`})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/event/event-list.vue